export const formatParam = (param) => {
  if (typeof param == 'string') {
    return param.replace(/&/gi, '%26');
  }
  return param;
};
